import { Link } from "react-router-dom";
import { t } from "@/lib/i18n";
import { usePublicSettings } from "@/hooks/useContent";
import { BrandMark } from "@/components/Brand";

const MORE = [["/how-it-works", "nav.howItWorks"], ["/who-can-receive-care", "nav.who"], ["/our-counselors", "nav.counselors"], ["/life-care-classes", "nav.classes"], ["/resources", "nav.resources"], ["/pray-with-us", "nav.pray"], ["/reach-out", "nav.reachOut"], ["/faq", "nav.faq"]];
const LEGAL = [["/crisis", "nav.crisis"], ["/privacy", "nav.privacy"], ["/terms", "nav.terms"], ["/sms-terms", "nav.smsTerms"], ["/accessibility", "nav.accessibility"]];

export const PublicFooter = () => {
  const { data } = usePublicSettings();
  const campuses = data?.settings?.["org.campuses"] || [];
  const phone = data?.settings?.["org.front_desk_phone"] || "(909) 987-7110";
  return (
    <footer className="mt-20 border-t border-sage-400/60 bg-cream-100" data-testid="public-footer">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4">
        <div className="md:col-span-1">
          <img src="/brand/wordmark-ink.png" alt="Patria" className="h-6 w-auto" width="930" height="250" />
          <p className="mt-2 text-ink-900">{t("brand.sub")}</p>
          <BrandMark kind="branch" tone="ink" className="mt-6 h-10 w-auto opacity-80" />
          <p className="mt-4 text-sm text-ink-500 max-w-[36ch]">{t("brand.ministry")}</p>
          <p className="mt-4 text-base">
            {t("footer.frontDesk")}: <a href={`tel:${phone.replace(/\D/g, "")}`} className="link" data-testid="footer-front-desk-phone">{phone}</a>
          </p>
        </div>
        <div>
          <h2 className="text-lg">{t("footer.campuses")}</h2>
          <ul className="mt-3 space-y-1.5 text-ink-900">{campuses.map((c) => <li key={c}>{c}</li>)}</ul>
        </div>
        <div>
          <h2 className="text-lg">{t("footer.more")}</h2>
          <ul className="mt-3 space-y-1.5">{MORE.map(([to, k]) => <li key={to}><Link to={to} className="link font-normal no-underline hover:underline">{t(k)}</Link></li>)}</ul>
        </div>
        <div>
          <h2 className="text-lg">{t("footer.legal")}</h2>
          <ul className="mt-3 space-y-1.5">{LEGAL.map(([to, k]) => <li key={to}><Link to={to} className="link font-normal no-underline hover:underline">{t(k)}</Link></li>)}</ul>
        </div>
      </div>
      <div className="border-t border-sage-400/40">
        <div className="mx-auto max-w-6xl px-4 py-6 text-sm text-ink-500 sm:px-6 space-y-1">
          <p>{t("footer.org")}</p>
          <p>{t("footer.noTrackers")}</p>
        </div>
      </div>
    </footer>
  );
};
